import styles from './card-icons-container.module.css';

export function CardIconsContainer() {
  return (
    <div className={styles.iconContainer}>
      <img src="/amex.svg" alt="" />
      <img src="/mastercard.svg" alt="" />
      <img src="/visa.svg" alt="" />
      <img src="/discover.svg" alt="" />
    </div>
  );
}
